import { z } from "zod";
import { TReadAccess } from "../../common/readAccess";
import { TTranslationData } from "../../common/translation";

export const TRawCompanySettingsGeneral = z.object({
  actionValidator: z
    .record(
      z.object({
        allowedGroups: z.array(z.string()),
      })
    )
    .optional(),
  administratedCompaniesName: TTranslationData.optional(),
  appPages: z
    .record(
      z.object({
        order: z.array(z.string()).optional(),
        readAccess: TReadAccess.optional(),
        pageTitles: z.record(TTranslationData).optional(),
      })
    )
    .optional(),
  memberVisibility: z
    .record(z.union([z.literal("opt-in"), z.literal("opt-out")]))
    .optional(),
  propertyFields: z
    .record(
      z.object({
        enabled: z.boolean(),
      })
    )
    .optional(),
  roleTitles: z
    .record(
      z.object({
        id: z.string().nullish(),
        singular: z.string().nullish(),
        plural: z.string().nullish(),
      })
    )
    .optional(),
  standardLangCode: z.string().optional(),
  unitFields: z
    .record(
      z.object({
        enabled: z.boolean(),
      })
    )
    .optional(),
});
export type IRawCompanySettingsGeneral = z.infer<
  typeof TRawCompanySettingsGeneral
>;

export const TApiSettingsResponse = z.object({
  data: TRawCompanySettingsGeneral,
});
export type IApiSettingsResponse = z.infer<typeof TApiSettingsResponse>;
